import React from 'react';
// import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import Row from '@/src/components/Layouts/Row/Row';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import TextArea from '@/src/components/Antd/TextArea/TextArea';
import { Input } from '@/src/components/Antd';
// import FormItem from '../../components/FormItem/FormItem';
import CountWords from '@/src/components/CountWords/CountWords';
import Select, { OptionsList } from '@/src/components/Antd/Select/Select';

import css from './css.less';
import GlobalButton from '@/src/components/Antd/Button/Button';
import { PlusOutlined } from '@ant-design/icons';
import AddCode from 'src/pages/ProductEditor/Components/AddCodeModal/AddCode';

import SmartInput from '@/src/components/SmartInput/SmartInput';
import AddUnit from '../../../../constrains/SingleAddModal/AddUnit';
//import Status from 'src/pages/ProductEditor/Components/StatusTag/Status';
import Configuration from '@/src/components/Configuration/Configuration';
import { EnumProductType } from 'src/types/common/product';
import { getError, getErrorTip } from 'src/tools/helper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const VirtualProductInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    setShowModal,
    setModalTitle,
    // setOkText,
    setModalContent,
    data,
    setData,
    // status,
    // setDraft,
    // setActive,
    // setArchived,
    brands = [],
    addBrand,
    codesOnChange,
    deletePopFun,

    onTypeChange,
    productType,
    disabled,
    ids = {},
    // title,
  } = props;

  const handleOnCodeSubmit = (code) => {
    setData({
      codes: [...codes, code],
    });
  };

  const { name, remarks, brand, description, codes, sku } = data;

  const barcodeDisable = React.useMemo(() => {
    if ((codes || []).length < 10) {
      return false;
    }
    return true;
  }, [(codes || []).length]);

  const brandOnSubmit = (brand) => {
    if (addBrand) addBrand(brand);
    // setData({
    //   brands: [...brands, { name: brand, uuid: JSON.stringify(new Date()) }],
    // });
  };

  const addInputData = () => {
    setShowModal(true);
    setModalTitle(
      getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_add_othercode',
      ),
    );
    // setOkText('Create');
    //otherCodeForm.resetFields();
    const child = (
      <AddCode
        setModal={setShowModal}
        onSubmit={handleOnCodeSubmit}
        firstMaxLength={50}
        secondMaxLength={50}
        disabled={disabled}
      />
    );
    setModalContent(child);
  };

  const selectOptionConvert = (arr = []): OptionsList[] => {
    return arr.map((i) => {
      return {
        label: i.name,
        value: i.uuid,
      };
    });
  };

  const brandBtnClick = () => {
    setShowModal(true);
    setModalTitle(
      getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_add_newproductbrand',
      ),
    );
    // setOkText('Create');
    const child = (
      <Row
        elements={[
          {
            child: (
              <AddUnit
                title={getI18n(
                  'allProducts.addproductset.productInfo_component_productinfo_brand_title',
                )}
                setModal={setShowModal}
                onSubmit={brandOnSubmit}
                disabled={disabled}
              />
            ),
          },
        ]}
      />
    );
    setModalContent(child);
  };

  return (
    // <SectionWrapper
    //   titleClassName={css.titleContainer}
    //   title={

    //   }>
    <React.Fragment>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                id={ids.productInfoProductName}
                rightPart={
                  <CountWords count={(name || '').length} allCount={100} />
                }
                title={`${getI18n('general.productName')}*`}>
                <TextArea
                  disabled={disabled}
                  // status={EnumFormItemStatus.error}
                  // help={'test'}
                  error={getError('name', data)}
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  size='large'
                  value={name}
                  maxLength={100}
                  onChange={(value) => setData({ name: value })}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper title={`${getI18n('general.type')}*`}>
                <Select
                  disabled={disabled}
                  optionsList={[
                    {
                      label: getI18n('general.service'),
                      value: EnumProductType.Service,
                    },
                    {
                      label: getI18n('general.giftCard'),
                      value: EnumProductType.GiftCard,
                    },
                  ]}
                  size='large'
                  value={productType}
                  onChange={onTypeChange}
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords count={(remarks || '').length} allCount={500} />
                }
                title={getI18n('general.remarks')}
                rightSubTitle={getI18n(
                  'allProducts.addproductset.productInfo_component_productinfo_remarks_rightSubTitle',
                )}
                help='1111111'
                validateStatus='error'>
                <TextArea
                  disabled={disabled}
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  value={remarks}
                  onChange={(value) => setData({ remarks: value })}
                  maxLength={500}
                  size='large'
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                title={`${getI18n('allProducts.addproductset.virtualSKUNo')}*`}
                rightPart={
                  <CountWords count={(sku || '').length} allCount={50} />
                }>
                <Input
                  disabled={disabled}
                  help={
                    getErrorTip('sku', data) ||
                    getI18n('allProducts.addproductset.skucannotbeempty')
                  }
                  error={getError('sku', data)}
                  size='large'
                  value={sku}
                  maxLength={50}
                  onChange={(value) => setData({ sku: value })}
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <React.Fragment>
                <ItemWrapper
                  title={getI18n(
                    'allProducts.addproductset.productInfo_component_productinfo_brand_title',
                  )}>
                  <Select
                    disabled={disabled}
                    optionsList={selectOptionConvert(brands)}
                    size='large'
                    value={(brand || {}).uuid}
                    onChange={(value, option) => {
                      setData({
                        brand: {
                          name: option.children,
                          uuid: value,
                        },
                      });
                    }}
                    rightBtn={{
                      type: 'add',
                      disabled,
                      clickFun: brandBtnClick,
                    }}
                  />
                </ItemWrapper>
                <ItemWrapper
                  rightPart={
                    <CountWords
                      count={(description || '').length}
                      allCount={500}
                    />
                  }
                  title={getI18n(
                    'allProducts.addproductset.productInfo_component_productinfo_product_desc',
                  )}>
                  <TextArea
                    disabled={disabled}
                    maxLength={500}
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    size='large'
                    onChange={(value) => setData({ description: value })}
                    value={description}
                  />
                </ItemWrapper>
                <Configuration />
              </React.Fragment>
            ),
          },

          {
            child: (
              <ItemWrapper
                titleContainerClassName={css.titleContainerClassName}>
                <SmartInput
                  disabled={disabled}
                  otherCodeList={codes}
                  maxLength={50}
                  onChange={codesOnChange} //{ code: e, index }
                  confirm={(index) => deletePopFun(index)}
                />
                <GlobalButton
                  disabled={barcodeDisable || disabled}
                  className={css.addOtherBtn}
                  type='text'
                  icon={<PlusOutlined />}
                  onClick={() => addInputData()}>
                  {getI18n(
                    'allProducts.addproductset.productInfo_component_productinfo_add_othercode',
                  )}
                </GlobalButton>
              </ItemWrapper>
            ),
          },
        ]}
      />
      {/* <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords
                    count={(description || '').length}
                    allCount={500}
                  />
                }
                title='Product Description'>
                <TextArea
                  maxLength={500}
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  size='large'
                  onChange={(value) => setData({ description: value })}
                  value={description}
                />
              </ItemWrapper>
            ),
          },
          {
            child: <React.Fragment />,
          },
        ]}
      />

      <Row
        elements={[
          {
            child: <Configuration />,
          },
        ]}
      /> */}
    </React.Fragment>
  );
};
export default VirtualProductInfo;
